import React, { useEffect } from 'react'
import { clearSession } from '../../lib/utils'

function User({history, location, match}) {

    useEffect(() => {
      const query = new URLSearchParams(window.location.search)
      const flow = query.get('flow')
      const paramsUid = query.get('uid')
      const localUid = localStorage.getItem('uid')
      if (paramsUid && paramsUid !== localUid) {
        clearSession()
      }
      if (flow === 'ugc') {
          history.push(`/onboarding${location.search}`)
      }
      else{
          history.push(`/login${location.search}`)
      }
    }, [])
    
  return (
    <div></div>
  )
}

export default User